import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagementComponent } from './management.component';
import { ManagementRoutingRoutes } from './management-routing.routing';
import { SharedModule } from '@app/shared/shared.module';
import { UsersManagementComponent } from './users-management/users-management.component';
import { UsersService } from './users-management/users-service.service';
import { InviteUserComponent } from './users-management/invite-user/invite-user.component';
import { UserRecordComponent } from './users-management/user-record/user-record.component';
import { ConfigurationGroupComponent } from './configuration-group/configuration-group.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, ManagementRoutingRoutes,TranslateModule, SharedModule],
  declarations: [
    ManagementComponent,
    UsersManagementComponent,
    InviteUserComponent,
    UserRecordComponent,
    ConfigurationGroupComponent,
  ],
  providers: [UsersService],
})
export class ManagementModule {}
